import React, { useEffect, useState, useRef } from "react";
import { useLocation, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";
import parse from "html-react-parser";
import $ from "jquery";
import * as Yup from "yup";
import moment from "moment";
import AWS from "aws-sdk";
import { Col, Row } from "react-bootstrap";
import {
  createChatXrayMriAnalysisCompletion,
  createTextToSpeechCompletion,
  uploadMedicalRecord,
  getPatientReport,
  getPatientReportAnalysis,
  GetPocChatSideList,
  GetPocChatHistor,
  editPocChatRoom,
} from "../../../api/apiHandler";
import Swal from "sweetalert2";
import styles from "./Anaylysischat.module.scss";
import Header from "../../../components/header/Header";
import { Button } from "react-bootstrap";
import Footer from "../../../components/footer/Footer";
// import randtoken from 'rand-token'

import "react-h5-audio-player/lib/styles.css";
import { v4 as uuidv4 } from "uuid";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import queryString from "query-string";
import pdficon from "../../../assets/pdf.png";
import constant from "../../../constant/constant";
import constantFunc from "../../../constant/constantFunc";
import txtIcon from "../../../assets/txtIcon.png";
import docIcon from "../../../assets/doc.png";
import xlsxIcon from "../../../assets/xlsx.jpg";
import styled from "styled-components";
import AutoPrescriptionPopup from "../../../components/footer/Common/AutoPrescriptionPopup";
export default function SearchChatGpt({ from }) {
  const [step, setStep] = useState("1");

  const location = useParams();
  console.log(location, "location");

  const audioRef = useRef(null);
  const fileInputRef = useRef(null);
  const [pocType, setPocType] = useState(location.poc_type);
  const [conversation, setConversation] = useState([]);
  // const [audioSrc, setAudioSrc] = useState("");
  const [searchValue, setSearchValue] = useState("");
  console.log("searchValue: ", searchValue);
  const [optionSelected, setOptionSelected] = useState(false);
  const [uuid, setUuid] = useState("");

  const [isNewchat, setIsNewChat] = useState(1);
  const [handleSweetAlert, setHandleSweetAlert] = useState(true);
  const [showListeningModal, setListeningModal] = useState(false);
  const [handleStartStopListening, setStartStopListening] = useState(true);
  const [image, setImage] = useState("");
  const [hints, setHints] = useState(constant?.illustration_radiographic);
  const [fileType, setFileType] = useState(null);
  const [showChat, setShowChat] = useState(true);
  const [uploadImage, setUploadImage] = useState(null);
  const { interimTranscript, resetTranscript, transcript, listening } =
    useSpeechRecognition();

  const [startDate, setStartDate] = useState(moment().format("YYYY-MM-DD"));
  const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
  const [recordType, setRecordType] = useState(0);
  const [instruction] = useState(constant?.auto_rx_instruction);
  console.log("recordType: ", recordType);

  const [uploadPaperRecord, setUploadPaperRecord] = useState(null);
  const [paperRecordImage, setPaperRecordImage] = useState(null);

  const [uploadEFileRecord, setUploadEFileRecord] = useState(null);
  const [eFileRecordImage, setEFileRecordImage] = useState(null);

  const [uploadVoiceCameraRecord, setUploadVoiceCameraRecord] = useState(null);
  const navigate = useNavigate();
  const [showActions, setShowActions] = useState(null);
  const dropdownRef = useRef();

  // Close dropdown on outside click
  // useEffect(() => {
  //   const handleClickOutside = (event) => {
  //     if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
  //       setShowActions(null);
  //     }
  //   };
  //   document.addEventListener("mousedown", handleClickOutside);
  //   return () => document.removeEventListener("mousedown", handleClickOutside);
  // }, [dropdownRef, setShowActions]);
  const [audioData, setAudioData] = useState({
    url: "",
    text: "",
    playStatus: false,
  });
  const inputRef = useRef(null);
  useEffect(() => {
    generateUuidIfEmpty();
  }, []);
  const handleAudioEnd = () => {
    // console.log('Audio has ended');
    setAudioData((prev) => ({ ...prev, playStatus: false }));
    // Add any additional logic you want to execute when audio ends here
  };

  const stopAudio = () => {
    // console.log('Audio has Stoped');
    setAudioData((prev) => ({ ...prev, playStatus: false }));
    audioRef.current.pause();
    audioRef.current.currentTime = 0; // Resets audio to the start
  };

  useEffect(() => {
    let timeoutId;

    const resetTimer = () => {
      clearTimeout(timeoutId);
      startTimer();
    };

    const startTimer = () => {
      timeoutId = setTimeout(() => {
        if (!searchValue.trim()) {
          Swal.fire({
            title: "Please make a request",
            icon: "warning",
          });
        }
      }, 120000);
    };

    if (optionSelected) {
      startTimer();

      const eventListeners = [
        "mousemove",
        "keydown",
        "click",
        "touchstart",
        "scroll",
      ];

      eventListeners.forEach((event) => {
        window.addEventListener(event, resetTimer);
      });

      return () => {
        clearTimeout(timeoutId);
        eventListeners.forEach((event) => {
          window.removeEventListener(event, resetTimer);
        });
      };
    }
  }, [searchValue, optionSelected]);

  // useEffect(() => {
  //   if (optionSelected) {
  //     poccreateChatAnalysisCompletion("Hello", uuid);
  //   }
  // }, [optionSelected]);

  const onImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      console.log("event.target.files[0]==>", event.target.files[0]);
      const allowedTypes = [
        "image/jpeg",
        "image/jpg",
        "image/png",
        "application/pdf",
        "text/plain",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      ];
      if (allowedTypes.includes(event.target.files[0].type)) {
        const fileSizeLimit = 10 * 1024 * 1024;
        if (event.target.files[0].size > fileSizeLimit) {
          Swal.fire({
            position: "top-end",
            icon: "error",
            title: "File size exceeds the limit of 10 MB",
            toast: true,
            showConfirmButton: false,
            timer: 3000,
          });
        } else {
          setImage(URL.createObjectURL(event.target.files[0]));
          setUploadImage(event.target.files[0]);
          if (event.target.files[0].type == "application/pdf") {
            setFileType("pdf");
          } else if (event.target.files[0].type == "text/plain") {
            setFileType("text");
          } else if (
            event.target.files[0].type ==
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
          ) {
            setFileType("doc");
          } else if (
            event.target.files[0].type ==
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          ) {
            setFileType("xlsx");
          } else {
            setFileType("image");
          }
        }
      } else {
        Swal.fire({
          position: "top-end",
          icon: "error",
          title:
            "Only Image File(png, jpeg, jpg, PDF, Text, docx, xlsx) Type Allowed!",
          toast: true,
          showConfirmButton: false,
          timer: 3000,
        });
      }
    }
  };

  const uploadData = async (file, folder_type) => {
    const S3_BUCKET = process.env.REACT_APP_AWS_S3_NAME;
    const REGION = process.env.REACT_APP_AWS_S3_REGION;

    AWS.config.update({
      accessKeyId: process.env.REACT_APP_AWS_S3_ACCESS_KEY,
      secretAccessKey: process.env.REACT_APP_AWS_S3_SECRET_KEY,
      region: REGION,
    });
    const ext = file.name.split(".").pop();
    const s3 = new AWS.S3({
      params: { Bucket: S3_BUCKET },
      region: REGION,
    });

    try {
      const newFileName = new Date().getTime() + "." + ext;
      const params = {
        Bucket: S3_BUCKET + folder_type,
        Key: newFileName,
        Body: file,
        ACL: "public-read",
      };
      return new Promise((resolve, reject) => {
        s3.putObject(params, (err, data) => {
          if (err) {
            reject(err);
          } else {
            resolve(newFileName);
          }
        });
      });
    } catch (error) {
      console.error("Error in UploadData:", error);
    }
  };

  const generateUuidIfEmpty = () => {
    if (!uuid) {
      // const newUuid = randtoken.generate(16, "abcdefghijklnmopqrstuvwxyz");
      const newUuid = uuidv4();
      console.log("Generated uuid:", newUuid);
      setUuid(newUuid);
      // setTimeout(() => {
      //   Swal.fire({
      //     title: "Please wait...",
      //     didOpen: () => {
      //       Swal.showLoading();
      //     },
      //   });
      // }, 500);
    }
  };
  const showSweetAlert = () => {
    const userName = localStorage.getItem("user_name") || "";
    const isDoctor = from === "Doctor";
    const displayName = `${isDoctor ? "Dr. " : ""}${userName}`;

    Swal.fire({
      title: `Hello ${displayName}, how are you today?`,
      imageUrl: "/assets/images/logo.png", // No need for PUBLIC_URL in Next.js or React
      imageWidth: 150,
      imageHeight: 120,
      showCancelButton: true,
      confirmButtonText: "I'm feeling great",
      cancelButtonText: "I'm doing okay",
    }).then((result) => {
      setHandleSweetAlert(false);

      if (result.isConfirmed) {
        handleOptionSelection("Option 1");
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        handleOptionSelection("Option 2");
      }
    });
  };

  useEffect(() => {
    showSweetAlert();
  }, []);

  const handleOptionSelection = (option) => {
    setOptionSelected(true);
    // Swal.fire({
    //   title: "Please wait...",
    //   didOpen: () => {
    //     Swal.showLoading();
    //   },
    // });
  };

  let locationValue = useLocation();
  const queryParams = new URLSearchParams(locationValue.search);
  const gemini = queryParams.get("ai_type");

  const poccreateChatAnalysisCompletion = (prompt, uuid, image = "") => {
    Swal.fire({
      title: "Please wait...",
      didOpen: () => {
        Swal.showLoading();
      },
    });

    createChatXrayMriAnalysisCompletion({
      prompt: prompt,
      imgUrl: image,
      imgType: fileType,
      uuid: uuid,
      is_new_chat: isNewchat,
      type: parseInt(pocType),
      login_type_role: parseInt(localStorage.getItem("user_login_type_role")),
      ai_used: gemini,
    }).then((res) => {
      var response = JSON.parse(res);
      console.log(response, "response123434344");

      if (response.code == process.env.REACT_APP_SUCCESS) {
        if (fileInputRef.current) {
          fileInputRef.current.value = ""; // Clear the input field
        }
        setImage("");
        setUploadImage(null);
        setFileType("");
        setIsNewChat(0);

        setSearchValue("");

        const responseData = response.data.response;
        console.log(responseData, "sendmessage");
        if (responseData) {
          getChatHistory(uuid);
          getSideBarList();
          Swal.close();
        }
      } else {
        Swal.fire({
          position: "top-end",
          icon: "error",
          title: response.message,
          toast: true,
          showConfirmButton: false,
          timer: 2000,
        });
      }
      // if (!handleSweetAlert) {
      //   Swal.close();
      // }
    });
  };
  const [isEdit, setIsEdit] = useState(false);
  const [editRoom, setEditRoom] = useState({
    id: "",
    name: "",
    status: null,
  });
  let deleteChatRoom = async (val) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to delete this chat room?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    });

    if (result.isConfirmed) {
      try {
        let response = await editPocChatRoom({
          status: 0,
          id: val.id,
        });
        let parsed = JSON.parse(response);
        console.log(parsed, "responceahgdja");

        if (parsed.code === 200) {
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Record Deleted Successfully",
            toast: true,
            showConfirmButton: false,
            timer: 1000,
          });
          getSideBarList();
          getChatHistory(val.uuid);
        }
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Failed to delete",
          text: error.message || "Something went wrong.",
        });
      }
    }
  };

  const editChatRoom = async () => {
    try {
      console.log("====386====", editRoom);

      const response = await editPocChatRoom({
        id: editRoom.id,
        name: editRoom.name,
        status: editRoom.status,
      });
      let parsed = JSON.parse(response);
      console.log(parsed, "responceahgdja");
      if (parsed.code == 200) {
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Updated Successfully",
          toast: true,
          showConfirmButton: false,
          timer: 1000,
        });
        getSideBarList();
        setEditRoom({
          id: "",
          name: "",
          status: null,
        });
      }
    } catch (error) {
      Swal.fire({
        position: "top-end",
        icon: "error",
        title: error.message,
        toast: true,
        showConfirmButton: false,
        timer: 2000,
      });
    }
  };
  const [sidebarList, setSidebarList] = useState([]);
  console.log(sidebarList, "sidebarList");

  const getSideBarList = async () => {
    try {
      const response = await GetPocChatSideList({});

      // If response is a JSON string, parse it
      const parsed =
        typeof response === "string" ? JSON.parse(response) : response;

      console.log(parsed, "chatRessidebarponse");

      // Make sure to access the actual data
      setSidebarList(parsed?.data || []);
    } catch (error) {
      Swal.fire({
        position: "top-end",
        icon: "error",
        title: error?.message || "Failed to fetch sidebar list",
        toast: true,
        showConfirmButton: false,
        timer: 2000,
      });
    }
  };
  const [selectedRoom, setSelectedRoom] = useState(null);
  const getChatHistory = async (uuid) => {
    Swal.fire({
      title: "Please wait...",
      didOpen: () => {
        Swal.showLoading();
      },
    });
    try {
      const response = await GetPocChatHistor({ uuid });
      setSelectedRoom(uuid);
      const responseData =
        typeof response === "string" ? JSON.parse(response) : response;
      const messages = [];
      if (responseData) {
        Swal.close();
      }
      for (const item of responseData?.data || []) {
        const messageContent = JSON.parse(item.response);
        console.log(messageContent, "responschate3222Data");

        const convertedHTML = await constantFunc.convertMarkdownLinksToHTML(
          messageContent.choices?.[0].message.content
        );

        const convertedText = await constantFunc.convertMarkdownLinksToText(
          messageContent.choices?.[0].message.content
        );

        const newMsgObj = {
          role: messageContent.choices?.[0].message.role,
          message: convertedHTML,
          readMessage: convertedText,
          prompt: item.prompt,
          is_new_chat: item.is_new_chat,
        };

        messages.push(newMsgObj);
      }

      setConversation((prevConversation) => [...messages]);
    } catch (error) {
      console.log(error, "error23232323");

      Swal.fire({
        position: "top-end",
        icon: "error",
        title: error?.message || "Failed to fetch chat history",
        toast: true,
        showConfirmButton: false,
        timer: 2000,
      });
    }
  };

  console.log(conversation, "conversation");

  useEffect(() => {
    getSideBarList();
  }, []);

  const openListeningModal = () => {
    setListeningModal(true);
  };
  const autoPresc = async () => {
    try {
      const meetingDataObj = {
        uuid: uuid,
      };
      const serializedObject = queryString.stringify(meetingDataObj);
      let basePOint = from === "Doctor" ? "/doctor" : "/patient";
      const url = `${basePOint}/auto-prescription-poc?${serializedObject}`;
      setTimeout(() => {
        window.open(url, "_blank");
      }, 500);
    } catch (error) {}
  };

  useEffect(() => {
    $(inputRef.current).daterangepicker(
      {
        opens: "left",
      },
      function (start, end, label) {
        setStartDate(start.format("YYYY-MM-DD"));
        setEndDate(end.format("YYYY-MM-DD"));
      }
    );
  }, []);

  // upload paper record
  const uploadPaperRedordData = async (file, file_path) => {
    const S3_BUCKET = process.env.REACT_APP_AWS_S3_NAME;
    const REGION = process.env.REACT_APP_AWS_S3_REGION;

    AWS.config.update({
      accessKeyId: process.env.REACT_APP_AWS_S3_ACCESS_KEY,
      secretAccessKey: process.env.REACT_APP_AWS_S3_SECRET_KEY,
      region: REGION,
    });
    const ext = file.name.split(".").pop();
    const s3 = new AWS.S3({
      params: { Bucket: S3_BUCKET },
      region: REGION,
    });

    try {
      const newFileName = new Date().getTime() + "." + ext;
      const params = {
        Bucket: S3_BUCKET + file_path,
        Key: newFileName,
        Body: file,
        ACL: "public-read",
      };

      return new Promise((resolve, reject) => {
        s3.putObject(params, (err, data) => {
          if (err) {
            reject(err);
          } else {
            resolve(newFileName);
          }
        });
      });
    } catch (error) {
      console.error("Error in UploadPaperRecordData:", error);
    }
  };

  const handlePaperRecord = (e) => {
    console.log("e--> paper record", e.target.files[0]);
    const fileExtension = e.target.files[0].name.split(".").pop().toLowerCase();
    if (["jpeg", "jpg", "png"].includes(fileExtension)) {
      setPaperRecordImage(URL.createObjectURL(e.target.files[0]));
      setUploadPaperRecord(e.target.files[0]);
    } else {
      setPaperRecordImage(null);
      setUploadPaperRecord(null);
      Swal.fire({
        position: "top-end",
        icon: "error",
        title: "Please Upload Valid File Type : ['jpeg', 'jpg', 'png']",
        toast: true,
        showConfirmButton: false,
        timer: 2000,
      });
    }
  };
  const emptyImage = async () => {
    try {
      if (fileInputRef.current) {
        fileInputRef.current.value = ""; // Clear the input field
      }
      setImage("");
      setUploadImage(null);
      setFileType("");
    } catch (error) {}
  };
  const handleEFile = (e) => {
    const fileExtension = e.target.files[0].name.split(".").pop().toLowerCase();
    if (["jpeg", "jpg", "png"].includes(fileExtension)) {
      setEFileRecordImage(URL.createObjectURL(e.target.files[0]));
      setUploadEFileRecord(e.target.files[0]);
    } else {
      setEFileRecordImage(null);
      setUploadEFileRecord(null);
      Swal.fire({
        position: "top-end",
        icon: "error",
        title: "Please Upload Valid File Type : ['jpeg', 'jpg', 'png']",
        toast: true,
        showConfirmButton: false,
        timer: 2000,
      });
    }
  };

  const handleVoiceCameraRecord = (e) => {
    setUploadVoiceCameraRecord(e.target.files[0]);
  };

  // validation for download medical record
  const validationSchema = Yup.object().shape({
    // record_name: Yup.string()
    //     .required("Please enter name of record")
    //     .matches(/^[aA-zZ\s]+$/, 'Only alphabets are allowed for this field'),
    // permission_code: Yup.string()
    //     .required('Please enter permission code'),
    specific_record: Yup.string().required("Please select specific record"),
  });

  const formOptions = { resolver: yupResolver(validationSchema) };
  const { register, handleSubmit, formState, setValue } = useForm(formOptions);
  const { errors } = formState;

  const handleEmailInput = async () => {
    const email = prompt("Enter your email:");
    if (email === null) return handleEmailInput();
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(email)) {
      Swal.fire({
        position: "top-end",
        icon: "error",
        title: "Please enter a valid email address",
        toast: true,
        showConfirmButton: false,
        timer: 1000,
      });
      return handleEmailInput();
    }
    return email;
  };
  const chatRef = useRef(null);

  useEffect(() => {
    if (searchValue.trim() !== "") {
      chatRef.current?.focus();
    }
  }, [searchValue]);

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();

      if (e.target.value.trim() === "") return;

      onSubmitChat();
    }
  };
  const onSubmitChat = async () => {
    if (!uploadImage) {
      console.log("searchValue--->", searchValue);
      poccreateChatAnalysisCompletion(
        searchValue,
        selectedRoom ? selectedRoom : uuid
      );
      setSearchValue("");
    } else {
      console.log("data: ");
      let imgUrl = "";
      await uploadData(uploadImage, "/analysis_file")
        .then((newImage) => {
          Swal.close();
          console.log("newImagenewImagenewImage", newImage);
          imgUrl = newImage;
        })
        .catch((e) => {
          Swal.close();
        });
      poccreateChatAnalysisCompletion(
        searchValue,
        selectedRoom ? selectedRoom : uuid,
        `https://msh-dev.s3.amazonaws.com/analysis_file/${imgUrl}`
      );
      setShowChat(true);
    }
  };

  // validation for upload medical record
  const validationSchema2 = Yup.object().shape({
    imageType: Yup.string().required("Please select your image type"),
    paperRecord: Yup.mixed().test(
      "fileType",
      "Invalid file type. Only JPG, JPEG, and PNG files are allowed.",
      (value) => {
        if (value && value.length > 0) {
          const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];
          return allowedTypes.includes(value[0].type);
        }
        // If value is not present (empty), consider it as valid.
        return true;
      }
    ),

    eFile: Yup.mixed().test(
      "fileType",
      "Invalid file type. Only JPG, JPEG, and PNG files are allowed.",
      (value) => {
        if (value && value.length > 0) {
          const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];
          return allowedTypes.includes(value[0].type);
        }
        // If value is not present (empty), consider it as valid.
        return true;
      }
    ),

    voiceCameraRecord: Yup.mixed().test(
      "fileType",
      "Invalid file type. Only MP3 and MP4 files are allowed.",
      (value) => {
        if (value && value.length > 0) {
          const allowedTypes = ["audio/mp3", "video/mp4"];
          return allowedTypes.includes(value[0].type);
        }
        // If value is not present (empty), consider it as valid.
        return true;
      }
    ),
  });

  const formOptions2 = { resolver: yupResolver(validationSchema2) };
  const {
    register: register2,
    handleSubmit: handleSubmit2,
    formState: { errors: errors2 },
  } = useForm(formOptions2);

  const pocCreateTextToSpeechCompletion = (msg) => {
    if (audioData?.text && audioData?.text == msg) {
      setAudioData((prev) => ({ ...prev, playStatus: true }));
      audioRef.current.src = audioData?.url;
      audioRef.current.controls = true;
      audioRef.current.play();
    } else {
      Swal.fire({
        title: "Please wait...",
        didOpen: () => {
          Swal.showLoading();
        },
      });
      createTextToSpeechCompletion({ text: msg }).then((res) => {
        // console.log('response===>', res)
        var response = JSON.parse(res);
        if (response.code == process.env.REACT_APP_SUCCESS) {
          const arrayBuffer = response.data.buffer.data;
          console.log("arrayBuffer==>", arrayBuffer);
          // Convert buffer data to Blob
          const byteArray = new Uint8Array(arrayBuffer);
          const blob = new Blob([byteArray], { type: "audio/mpeg" });
          // const blob = new Blob([arrayBuffer], { type: 'audio/mp3' });
          const url = URL.createObjectURL(blob);
          // setAudioSrc(url)
          // const audio = new Audio(url);
          console.log("url==>", url);
          if (audioRef.current) {
            console.log("test");
            audioRef.current.src = url;
            audioRef.current.controls = true;
            audioRef.current.play();
            setAudioData({
              url: url,
              text: msg,
              playStatus: true,
            });
          } else {
            // console.log("testfsed")
          }
        } else {
          Swal.fire({
            position: "top-end",
            icon: "error",
            title: response.message,
            toast: true,
            showConfirmButton: false,
            timer: 2000,
          });
        }
        if (!handleSweetAlert) {
          Swal.close();
        }
      });
    }
  };

  const closeListeningModal = () => {
    SpeechRecognition.stopListening();
    resetTranscript();
    setStartStopListening(true);
    setListeningModal(false);
    // setValue('prompt', searchValue, { shouldValidate: false })
  };

  const handleListening = () => {
    if (handleStartStopListening) {
      SpeechRecognition.startListening({ continuous: true, timeout: 5000 });
      setStartStopListening(false);
    } else {
      // SpeechRecognition.stopListening();
      // resetTranscript()
      // setStartStopListening(true)
      closeListeningModal();
    }
  };

  useEffect(() => {
    let timeout;
    if (transcript) {
      console.log("transcript: ", transcript);

      clearTimeout(timeout);
      timeout = setTimeout(() => {
        setSearchValue(transcript);
      }, 1000);
    } else {
      console.log("transscrpt functirn calluued");
    }
    return () => clearTimeout(timeout);
  }, [transcript, resetTranscript]);
  const chatBoxRef = useRef(null);
  const lastMessageRef = useRef(null);
  const [isAutoScroll, setIsAutoScroll] = useState(true);

  const handleScroll = () => {
    const el = chatBoxRef.current;
    const isUserAtBottom =
      el.scrollHeight - el.scrollTop - el.clientHeight < 10;
    setIsAutoScroll(isUserAtBottom);
  };
  useEffect(() => {
    if (isAutoScroll && lastMessageRef.current) {
      lastMessageRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [conversation]);
  useEffect(() => {
    if (chatBoxRef.current) {
      chatBoxRef.current.scrollTop = chatBoxRef.current.scrollHeight;
    }
  }, [conversation]);

  return (
    <>
      <Header />
      <section
        style={{
          background: "#efefef",
        }}
      >
        <div className="container-fluid"></div>
        <ChatBoxWrpper className="">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-2 col-md-3 p-0">
                <div
                  className="py-2 chatSidebar"
                  style={{
                    maxHeight: "calc(100vh - 120px)",
                    overflow: "auto",
                    scrollbarWidth: "none", // For Firefox
                    msOverflowStyle: "none", // For IE/Edge
                  }}
                >
                  <div className="py-2">
                    <ul className="list-unstyled ps-0 mb-0">
                      <li>
                        <button
                          onClick={() => {
                            const newUuid = uuidv4();

                            poccreateChatAnalysisCompletion("Hello", newUuid);
                          }}
                          className=" newchat border-0 p-3 rounded  text-white d-flex align-items-center gap-2 shadow-sm"
                        >
                          <span className="fw-semibold">
                            {newCHat} New Chat
                          </span>
                        </button>
                      </li>
                    </ul>
                  </div>

                  <div className="py-2 ">
                    <h6 className="m-0 pb-3">Chats</h6>
                    <ul className="list-unstyled ps-0 mb-0">
                      {sidebarList?.map((val, key) => (
                        <li
                          // selectedRoom
                          className={`d-flex  py-2  justify-content-between`}
                          key={key}
                        >
                          <div
                            className={`chatsidebarroom ${
                              selectedRoom === val.uuid && "active"
                            }  p-2 rounded bg-body-tertiary `}
                          >
                            {editRoom?.id === val.id ? (
                              <div className="d-flex   align-items-center justify-content-between">
                                <input
                                  type="text"
                                  className="form-control"
                                  value={editRoom.name}
                                  onChange={(e) =>
                                    setEditRoom({
                                      ...editRoom,
                                      name: e.target.value,
                                    })
                                  }
                                  placeholder="Enter room name"
                                />
                                <span
                                  onClick={editChatRoom}
                                  className="ms-2 cursor-pointer savebttn "
                                >
                                  save
                                </span>
                              </div>
                            ) : (
                              <div
                                onClick={() => getChatHistory(val.uuid)}
                                className="d-flex   align-items-center justify-content-between cursor-pointer"
                              >
                                <button className="border-0 rounded bg-transparent text-start">
                                  {val.name != null
                                    ? val.name
                                    : val.lastMessage}
                                </button>
                                <div
                                  className="position-relative"
                                  ref={dropdownRef}
                                >
                                  <div
                                    className="cursor-pointer"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setShowActions(
                                        showActions === key ? null : key
                                      );
                                    }}
                                  >
                                    {dots}
                                  </div>

                                  {showActions === key && (
                                    <div
                                      className="dropdown-menu show p-2 shadow"
                                      style={{
                                        display: "block",
                                        position: "absolute",
                                        top: "100%",
                                        right: 0,
                                      }}
                                    >
                                      <button
                                        className="dropdown-item"
                                        onClick={() => {
                                          setEditRoom({
                                            id: val.id,
                                            name: val.name || val.lastMessage,
                                            status: val.status ? 1 : 0,
                                          });
                                          setShowActions(null);
                                        }}
                                      >
                                        {editIcon} Rename
                                      </button>

                                      <button
                                        className="dropdown-item text-danger"
                                        onClick={() => {
                                          deleteChatRoom(val);
                                          setShowActions(null);
                                        }}
                                      >
                                        {deleteIcon} Delete
                                      </button>
                                    </div>
                                  )}
                                </div>
                              </div>
                            )}
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-lg-10 col-md-9">
                <div className="rounded" style={{ background: "#f4fdff" }}>
                  {selectedRoom !== null && (
                    <div className="top px-3 py-1 border-bottom">
                      <Row>
                        <Col md="6" className="my-2">
                          <div
                            className="border rounded p-2 text-center bg-white mx-auto h-100 d-flex align-items-center justify-content-center"
                            style={{ border: "2px dashed #9d9d9d" }}
                          >
                            <div className="text-center">
                              <div
                                className="poc-img d-flex align-items-center justify-content-center mb-1 mx-auto rounded-circle"
                                style={{
                                  background: "rgb(44 108 195)",
                                  height: 40,
                                  width: 40,
                                }}
                              >
                                <img
                                  src="/assets/images/icon/camera_3193058.png"
                                  alt=""
                                  className="img-fluid object-fit-contain"
                                  style={{ height: 25, filter: "invert(1)" }}
                                />
                              </div>
                              <h5 className="m-0 fw-bold">
                                {constant?.poc_apps?.[3]}
                              </h5>
                            </div>
                          </div>
                        </Col>
                        <Col md="6" className="my-2">
                          <div className="d-flex h-100 justify-content-center align-items-center gap-2">
                            <div
                              className="position-relative p-3 rounded w-100"
                              style={{ border: "2px dashed #9d9d9d" }}
                            >
                              {image && (
                                <Button
                                  onClick={emptyImage}
                                  className="border-0 position-absolute text-white  rounded-circle p-2 d-flex align-items-center justify-content-center"
                                  style={{
                                    top: 0,
                                    right: 0,
                                    zIndex: 999,
                                    transform: "translateY(-50%)",
                                    background: "#216fc8",
                                    height: 30,
                                    width: 30,
                                  }}
                                  variant="transparent"
                                >
                                  X
                                </Button>
                              )}
                              <input
                                type="file"
                                ref={fileInputRef}
                                onChange={onImageChange}
                                style={{
                                  left: 0,
                                  top: 0,
                                  zIndex: 99,
                                  opacity: 0,
                                }}
                                className="position-absolute h-100 w-100 file"
                              />
                              <div className="text-center">
                                {image && (
                                  <img
                                    src={
                                      (fileType == "pdf" && pdficon) ||
                                      (fileType == "text" && txtIcon) ||
                                      (fileType == "doc" && docIcon) ||
                                      (fileType == "xlsx" && xlsxIcon) ||
                                      image
                                    }
                                    alt=""
                                    className="img-fluid mx-auto object-fit-contain"
                                    style={{ height: 100, width: 100 }}
                                  />
                                )}
                                <p className="m-0 text-muted">Upload File</p>
                                <p
                                  className="m-0 text-muted"
                                  style={{ fontSize: 10 }}
                                >
                                  Upload File for Analysis
                                </p>
                              </div>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  )}

                  <div
                    className="bodyChat p-3 overflow-auto"
                    style={{ height: "calc(100vh - 200px)" }}
                  >
                    <div
                      ref={chatBoxRef}
                      style={{
                        overflowY: "auto",
                        maxHeight: "calc(100vh - 200px)",
                      }}
                      onScroll={handleScroll}
                    >
                      {selectedRoom !== null && conversation.length > 0 ? (
                        conversation?.map((entry, index) => (
                          <div key={index}>
                            <div
                              className="py-1"
                              ref={
                                index === conversation.length - 1
                                  ? lastMessageRef
                                  : null
                              }
                            >
                              <div className="d-flex align-items-start justify-content-end ourMessage">
                                <div className="chatMessage p-2 text-white">
                                  <pre className="mb-0 text-start text-wrap white-space-pre">
                                    {parse(entry.prompt)}
                                  </pre>
                                </div>
                                <div className="imgWrp flex-shrink-0">
                                  <img
                                    src={
                                      process.env.PUBLIC_URL +
                                      "/assets/images/logo.png"
                                    }
                                    alt=""
                                    className="img-fluid ms-2 object-fit-contain"
                                    style={{ height: 25 }}
                                  />
                                </div>
                              </div>
                            </div>

                            {/* Bot Reply */}
                            <div className="py-1">
                              <div className="d-flex align-items-start">
                                <div className="imgWrp flex-shrink-0">
                                  <img
                                    src={
                                      process.env.PUBLIC_URL +
                                      "/assets/images/logo.png"
                                    }
                                    alt=""
                                    className="img-fluid me-2 object-fit-contain"
                                    style={{ height: 25 }}
                                  />
                                </div>
                                <div className="chatMessage p-2 text-white">
                                  <pre className="mb-2 text-justify white-space-pre">
                                    {parse(entry.message)}
                                  </pre>

                                  {audioData?.playStatus &&
                                  audioData?.text ===
                                    parse(entry.readMessage) ? (
                                    <button
                                      className="search-btn"
                                      type="button"
                                      onClick={stopAudio}
                                    >
                                      <i className="fa-solid fa-pause text-white" />
                                    </button>
                                  ) : (
                                    <button
                                      className="border-0 p-0 bg-transparent text-white"
                                      type="button"
                                      onClick={() =>
                                        pocCreateTextToSpeechCompletion(
                                          parse(entry.readMessage)
                                        )
                                      }
                                    >
                                      {audioIcn}
                                    </button>
                                  )}
                                  <audio
                                    onEnded={handleAudioEnd}
                                    style={{ height: 0, width: 0, opacity: 0 }}
                                    ref={audioRef}
                                    controls
                                  >
                                    <source src="" type="audio/mpeg" />
                                  </audio>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))
                      ) : (
                        <>
                          <div className="text-center">
                            <div
                              className="poc-img d-flex align-items-center justify-content-center  mx-auto rounded-circle"
                              style={{
                                background: "rgb(44 108 195)",
                                height: 40,
                                width: 40,
                              }}
                            >
                              <img
                                src="/assets/images/icon/camera_3193058.png"
                                alt=""
                                className="img-fluid object-fit-contain"
                                style={{ height: 25, filter: "invert(1)" }}
                              />
                            </div>
                            <h5 className="m-0 fw-bold">
                              {constant?.poc_apps?.[3]}
                            </h5>
                          </div>
                          <div
                            className="d-flex justify-content-center align-items-center"
                            style={{ height: "calc(100vh - 300px)" }}
                          >
                            <div
                              className="interactive-box rounded shadow text-center fs-4 fw-semibold"
                              style={{ padding: "84px" }}
                            >
                              <div className="imgWrp flex-shrink-0 mb-3">
                                <img
                                  src={
                                    process.env.PUBLIC_URL +
                                    "/assets/images/logo.png"
                                  }
                                  alt="Logo"
                                  className="img-fluid ms-2 object-fit-contain"
                                  style={{ height: 50 }}
                                />
                              </div>
                              <span
                                onClick={() => {
                                  const newUuid = uuidv4();

                                  poccreateChatAnalysisCompletion(
                                    "Hello",
                                    newUuid
                                  );
                                }}
                                className="text-primary text-decoration-underline cursor-pointer"
                                role="button"
                              >
                                Click here
                              </span>{" "}
                              to start a new chat
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>

                  <div className="chatFooter p-3 bg-white border-top">
                    {hints?.length > 0 && (
                      <div className=" overflow-auto d-flex align-items-center gap-10 mb-3 px-4 w-100 bg-white">
                        {hints?.length > 0 &&
                          hints?.map((itm) => (
                            <OverlayTrigger
                              placement="top"
                              delay={{ show: 250, hide: 400 }}
                              overlay={
                                <Tooltip id="button-tooltip">{itm}</Tooltip>
                              }
                            >
                              <div
                                onClick={() => {
                                  setSearchValue(itm);
                                  setValue("prompt", itm);
                                  setTimeout(() => {
                                    chatRef.current?.focus();
                                  }, 0);
                                }}
                                className="d-block py-2 align-items-center justify-content-center btn commonBtn text-truncate px-3 rounded-pill"
                                style={{
                                  maxWidth: 300,
                                  fontSize: 12,
                                  flexShrink: 0,
                                }}
                              >
                                {itm}
                              </div>
                            </OverlayTrigger>
                          ))}
                      </div>
                    )}
                    <div className="d-flex justify-content-between align-content-center gap-10">
                      <div className="w-75">
                        <textarea
                          ref={chatRef}
                          rows={2}
                          type="text"
                          {...register("prompt")}
                          className="form-control  "
                          id="prompt"
                          style={{
                            Width: "00px",
                          }}
                          value={searchValue}
                          onChange={(e) => {
                            setSearchValue(e.target.value);
                          }}
                          placeholder={
                            parseInt(location.poc_type) == 7
                              ? "Hello I have a fever and a headache and some fatigue. What might be the problem? what do you need for accurate differential diagnosis?"
                              : parseInt(location.poc_type) == 2
                              ? "Please check the following prescription for interactions and indications. Please revise the prescription to remove interactions and ameliorate severe indications."
                              : " Send your message..."
                          }
                          onKeyDown={handleKeyDown}
                        />
                        <div className="invalid-feedback">
                          {errors.prompt?.message}
                        </div>
                      </div>
                      <div
                        className="d-flex gap-3 flex-shrink-0 "
                        // style={{ right: 0 }}
                      >
                        <button
                          className="btn  cursor-pointer  searchbtn"
                          type="button"
                          onClick={onSubmitChat}
                        >
                          {sendIcn}
                        </button>
                        <button
                          className="btn  cursor-pointer  searchbtn"
                          type="button"
                          onClick={openListeningModal}
                        >
                          {mikeIcn}
                        </button>
                        <AutoPrescriptionPopup
                          btnClass="btn  cursor-pointer  searchbtn"
                          instruction={instruction}
                          onConfirm={autoPresc}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ChatBoxWrpper>
      </section>

      <Footer />

      {showListeningModal && (
        <>
          <div
            className={`modal fade ${showListeningModal ? "show" : ""}`}
            id="staticBackdrop1"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            aria-labelledby="staticBackdropLabel"
            aria-hidden="true"
            tabIndex="-1"
            style={{ display: showListeningModal ? "block" : "none" }}
          >
            <div className="modal-dialog prescription-modal modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header border-0">
                  <h5 className="modal-title" id="staticBackdropLabel">
                    Listening
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={closeListeningModal}
                  />
                </div>
                <div className="modal-body">
                  <div className="text-center">
                    {!handleStartStopListening ? (
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/images/icon/icons8-sound.gif"
                        }
                        alt="search"
                      />
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn submit-btn font_18"
                    onClick={handleListening}
                  >
                    {handleStartStopListening ? "Start" : "Stop"}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show"></div>
        </>
      )}
    </>
  );
}

const ChatBoxWrpper = styled.div`
  padding: 10px;
  .chatSidebar {
    .chatsidebarroom {
      font-size: 14px;
      color: #4f4f4f;
      font-weight: 500;
      transition: 0.4s;
      width: 100%;
      &:hover {
        background: #c3c3c3 !important;
      }
    }
    .active {
      background: #c3c3c3 !important;
    }
    .savebttn {
      color: #216fc8 !important;
    }
    .newchat {
      font-size: 14px;
      color: #000 !important;
      background-color: #c3c3c3 !important;
      font-weight: 500;
      transition: 0.4s;
      width: 100%;
      &:hover {
        background-color: #216fc8 !important;
        color: #fff !important;
      }
    }

    .hovertarget {
      &:hover {
        display: block !important;
      }
    }
    h6 {
      font-size: 16px;
      font-weight: 600;
    }
  }
  .searchbtn {
    border-radius: 8px;
    padding: 16px;
    width: fit-content;
    height: fit-content;
    background-color: #216fc8 !important;
    cursor: pointer;
  }
  .infobtn {
    border-radius: 8px;
    padding: 15px;
    width: fit-content;
    height: fit-content;
    background-color: #216fc8 !important;
    cursor: pointer;
  }
  .bodyChat {
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }

    .chatMessage {
      background: #2c6cc3;
      border-radius: 10px;
      border-bottom-left-radius: 0;
      max-width: 500px;
      width: auto;
      display: inline-block;
      pre {
        font-size: 12px;
      }
    }
    .ourMessage {
      .chatMessage {
        background: #ddd;
        border-radius: 10px;
        border-bottom-right-radius: 0;
        pre {
          color: #000;
        }
      }
    }
  }
  .chatFooter {
    input {
      font-size: 14px;
      height: 45px;
      padding-right: 120px;
    }
    .formactnBtn {
      top: 50%;
      transform: translateY(-50%);
    }
  }
`;

const sendIcn = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.724 1.053C1.6403 1.01113 1.54653 0.993602 1.45336 1.0024C1.36019 1.01119 1.27135 1.04595 1.19696 1.10274C1.12257 1.15952 1.06561 1.23604 1.03256 1.32359C0.999506 1.41115 0.991689 1.50622 1.01 1.598L2.413 6.448C2.43916 6.53838 2.49029 6.61955 2.56052 6.68217C2.63075 6.74479 2.71722 6.78632 2.81 6.802L8.5 7.755C8.768 7.808 8.768 8.192 8.5 8.245L2.81 9.198C2.71722 9.21367 2.63075 9.2552 2.56052 9.31783C2.49029 9.38045 2.43916 9.46161 2.413 9.552L1.01 14.402C0.991689 14.4938 0.999506 14.5888 1.03256 14.6764C1.06561 14.764 1.12257 14.8405 1.19696 14.8973C1.27135 14.954 1.36019 14.9888 1.45336 14.9976C1.54653 15.0064 1.6403 14.9889 1.724 14.947L14.724 8.447C14.8069 8.40543 14.8767 8.3416 14.9254 8.26266C14.9742 8.18372 15 8.09277 15 8C15 7.90722 14.9742 7.81628 14.9254 7.73733C14.8767 7.65839 14.8069 7.59457 14.724 7.553L1.724 1.053Z"
      fill="#fff"
    />
  </svg>
);

const mikeIcn = (
  <svg
    width="14"
    height="20"
    viewBox="0 0 14 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.75 16.96V20H6.25V16.96C4.53323 16.775 2.94541 15.962 1.79173 14.6773C0.638056 13.3925 -7.26502e-05 11.7267 6.20374e-09 10V8H1.5V10C1.5 11.4587 2.07946 12.8576 3.11091 13.8891C4.14236 14.9205 5.54131 15.5 7 15.5C8.45869 15.5 9.85764 14.9205 10.8891 13.8891C11.9205 12.8576 12.5 11.4587 12.5 10V8H14V10C14.0001 11.7267 13.3619 13.3925 12.2083 14.6773C11.0546 15.962 9.46677 16.775 7.75 16.96ZM3 4C3 2.93913 3.42143 1.92172 4.17157 1.17157C4.92172 0.421427 5.93913 0 7 0C8.06087 0 9.07828 0.421427 9.82843 1.17157C10.5786 1.92172 11 2.93913 11 4V10C11 11.0609 10.5786 12.0783 9.82843 12.8284C9.07828 13.5786 8.06087 14 7 14C5.93913 14 4.92172 13.5786 4.17157 12.8284C3.42143 12.0783 3 11.0609 3 10V4Z"
      fill="#fff"
    />
  </svg>
);

const trxnIcn = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_1_6"
      style={{ maskType: "luminance" }}
      maskUnits="userSpaceOnUse"
      x="2"
      y="2"
      width="20"
      height="20"
    >
      <path
        d="M19.5 3H4.5C4.10218 3 3.72064 3.15804 3.43934 3.43934C3.15804 3.72064 3 4.10218 3 4.5V19.5C3 19.8978 3.15804 20.2794 3.43934 20.5607C3.72064 20.842 4.10218 21 4.5 21H19.5C19.8978 21 20.2794 20.842 20.5607 20.5607C20.842 20.2794 21 19.8978 21 19.5V4.5C21 4.10218 20.842 3.72064 20.5607 3.43934C20.2794 3.15804 19.8978 3 19.5 3Z"
        fill="white"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5 15.5L13 17.5L17 12.5M7 7.5H17M7 11.5H11"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </mask>
    <g mask="url(#mask0_1_6)">
      <path d="M0 0H24V24H0V0Z" fill="#fff" />
    </g>
  </svg>
);

const audioIcn = (
  <svg
    width="12"
    height="10"
    viewBox="0 0 12 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.60938 0L3.60938 3H0.609375V7H3.60938L6.60938 10V0ZM8.2175 0.864625L8.07187 1.40797C9.69894 1.84391 10.8281 3.31547 10.8281 5C10.8281 6.68453 9.69894 8.15606 8.07187 8.59203L8.2175 9.13538C10.0878 8.63422 11.3906 6.93631 11.3906 5C11.3906 3.06366 10.0878 1.36578 8.2175 0.864625ZM7.82922 2.31353L7.68366 2.85687C8.655 3.11712 9.32812 3.99444 9.32812 5C9.32812 6.00556 8.655 6.88287 7.68366 7.14312L7.82922 7.68647C9.04381 7.361 9.89062 6.25741 9.89062 5C9.89062 3.74259 9.04381 2.639 7.82922 2.31353ZM7.44097 3.76237L7.29544 4.30572C7.61094 4.39031 7.82812 4.67334 7.82812 5C7.82812 5.32666 7.61094 5.60969 7.29541 5.69428L7.44097 6.23763C7.99984 6.08788 8.39066 5.57856 8.39066 5C8.39066 4.42144 7.99984 3.91212 7.44097 3.76237Z"
      fill="currentColor"
    />
  </svg>
);

const newCHat = (
  <svg
    width="16"
    height="15"
    viewBox="0 0 16 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.5 3C1.5 2.60218 1.65804 2.22064 1.93934 1.93934C2.22064 1.65804 2.60218 1.5 3 1.5H13C13.3978 1.5 13.7794 1.65804 14.0607 1.93934C14.342 2.22064 14.5 2.60218 14.5 3V6.25C14.5 6.44891 14.579 6.63968 14.7197 6.78033C14.8603 6.92098 15.0511 7 15.25 7C15.4489 7 15.6397 6.92098 15.7803 6.78033C15.921 6.63968 16 6.44891 16 6.25V3C16 2.20435 15.6839 1.44129 15.1213 0.87868C14.5587 0.31607 13.7956 0 13 0H3C2.20435 0 1.44129 0.31607 0.87868 0.87868C0.31607 1.44129 0 2.20435 0 3L0 14.25C0.000130387 14.3982 0.0441878 14.5431 0.126608 14.6663C0.209028 14.7895 0.326113 14.8856 0.463076 14.9423C0.60004 14.999 0.750737 15.0138 0.896136 14.985C1.04154 14.9561 1.17511 14.8848 1.28 14.78L4.063 12H8.25C8.44891 12 8.63968 11.921 8.78033 11.7803C8.92098 11.6397 9 11.4489 9 11.25C9 11.0511 8.92098 10.8603 8.78033 10.7197C8.63968 10.579 8.44891 10.5 8.25 10.5H3.443L3.223 10.72L1.5 12.44V3ZM13 13C12.8011 13 12.6103 12.921 12.4697 12.7803C12.329 12.6397 12.25 12.4489 12.25 12.25V10.75H10.75C10.5511 10.75 10.3603 10.671 10.2197 10.5303C10.079 10.3897 10 10.1989 10 10C10 9.80109 10.079 9.61032 10.2197 9.46967C10.3603 9.32902 10.5511 9.25 10.75 9.25H12.25V7.75C12.25 7.55109 12.329 7.36032 12.4697 7.21967C12.6103 7.07902 12.8011 7 13 7C13.1989 7 13.3897 7.07902 13.5303 7.21967C13.671 7.36032 13.75 7.55109 13.75 7.75V9.25H15.25C15.4489 9.25 15.6397 9.32902 15.7803 9.46967C15.921 9.61032 16 9.80109 16 10C16 10.1989 15.921 10.3897 15.7803 10.5303C15.6397 10.671 15.4489 10.75 15.25 10.75H13.75V12.25C13.75 12.4489 13.671 12.6397 13.5303 12.7803C13.3897 12.921 13.1989 13 13 13Z"
      fill="#9C9C9C"
    />
  </svg>
);

let editIcon = (
  <svg
    width="14"
    height="14"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.06 6L12 6.94L2.92 16H2V15.08L11.06 6ZM14.66 0C14.41 0 14.15 0.1 13.96 0.29L12.13 2.12L15.88 5.87L17.71 4.04C18.1 3.65 18.1 3 17.71 2.63L15.37 0.29C15.17 0.09 14.92 0 14.66 0ZM11.06 3.19L0 14.25V18H3.75L14.81 6.94L11.06 3.19Z"
      fill="black"
    />
  </svg>
);

let deleteIcon = (
  <svg
    width="16"
    height="18"
    viewBox="0 0 16 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 18C2.45 18 1.97933 17.8043 1.588 17.413C1.19667 17.0217 1.00067 16.5507 1 16V3H0V1H5V0H11V1H16V3H15V16C15 16.55 14.8043 17.021 14.413 17.413C14.0217 17.805 13.5507 18.0007 13 18H3ZM5 14H7V5H5V14ZM9 14H11V5H9V14Z"
      fill="#D33E3E"
      fill-opacity="0.83"
    />
  </svg>
);

let dots = (
  <svg
    width="13"
    height="3"
    viewBox="0 0 13 3"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 1.25C10 0.918479 10.1317 0.600537 10.3661 0.366117C10.6005 0.131696 10.9185 0 11.25 0C11.5815 0 11.8995 0.131696 12.1339 0.366117C12.3683 0.600537 12.5 0.918479 12.5 1.25C12.5 1.58152 12.3683 1.89946 12.1339 2.13388C11.8995 2.3683 11.5815 2.5 11.25 2.5C10.9185 2.5 10.6005 2.3683 10.3661 2.13388C10.1317 1.89946 10 1.58152 10 1.25ZM5 1.25C5 0.918479 5.1317 0.600537 5.36612 0.366117C5.60054 0.131696 5.91848 0 6.25 0C6.58152 0 6.89946 0.131696 7.13388 0.366117C7.3683 0.600537 7.5 0.918479 7.5 1.25C7.5 1.58152 7.3683 1.89946 7.13388 2.13388C6.89946 2.3683 6.58152 2.5 6.25 2.5C5.91848 2.5 5.60054 2.3683 5.36612 2.13388C5.1317 1.89946 5 1.58152 5 1.25ZM0 1.25C0 0.918479 0.131696 0.600537 0.366117 0.366117C0.600537 0.131696 0.918479 0 1.25 0C1.58152 0 1.89946 0.131696 2.13388 0.366117C2.3683 0.600537 2.5 0.918479 2.5 1.25C2.5 1.58152 2.3683 1.89946 2.13388 2.13388C1.89946 2.3683 1.58152 2.5 1.25 2.5C0.918479 2.5 0.600537 2.3683 0.366117 2.13388C0.131696 1.89946 0 1.58152 0 1.25Z"
      fill="black"
    />
  </svg>
);
